import { h, Component } from "preact";
import Style from "../../styles/Style";
import axios from "axios";
import Cookies from "js-cookie";
import { List } from "immutable";
window.io = require("socket.io-client");
import Echo from "laravel-echo";
import { MessageRecord } from "../../data/MessageRecord";
import Writing from "./Writing";
import { Howl } from "howler";
import Widget from "./widget/Widget";
import Invite from "./Invite";

export const TYPE_MESSAGE_USER = 1;
export const TYPE_MESSAGE_BOT_OPERATOR = 4;

export default class App extends Component {
    inviteTimeout = false;

    static defaultProps = {
        embed: false,
    };

    state = {
        authorized: false,
        open: !!(this.props.open || this.isEmbed),
        soundNotifications: true,
        loadBtn: true,
        fullScreen: false,
        messages: List(),
        textEnabled: true,
        input: "",
        typingMessage: null,
        botTyping: false,
        newMessage: 0,
        sizeEnough: true,
        file: null,
        showMenu: false,
        invite: false,
        lastMessage: null,
        using_live_chat: false,
        authCookie: null,
    };

    get isEmbed() {
        return !!~~this.props.embed;
    }

    constructor(props) {
        super(...arguments);

        this.toggleOpen = this.toggleOpen.bind(this);
        this.toggleNotifications = this.toggleNotifications.bind(this);
        this.toggleFullScreen = this.toggleFullScreen.bind(this);

        this.sendMessage = this.sendMessage.bind(this);
        this.scrollBottom = this.scrollBottom.bind(this);
        this.closeInvite = this.closeInvite.bind(this);
        this.openInvite = this.openInvite.bind(this);
        this.getMessageImage = this.getMessageImage.bind(this);

        this.client = axios.create({
            baseURL: this.props.baseURL,
            headers: {
                common: {
                    Authorization: this.isExAuth ? null : `Bearer ${Cookies.get(
                        this.getSessionName("token"),
                    )}`,
                    ClientOnly: "1",
                },
            },
        });

        this.webhook = axios.create({
            headers: {
                common: {
                    ClientOnly: "1",
                },
            },
        });

        this.sound = new Howl({
            src: [this.props.configs.message_notification],
        });

        window.addEventListener("message", (event) => {
            try {
                const { type, params } = JSON.parse(event.data);
                if (type === "sizeEnough") {
                    this.updateSizeEnough(true);
                }
                if (type === "sizeIsNotEnough") {
                    this.updateSizeEnough(false);
                }
                if (type === "postMessage") {
                    this.sendMessage(
                        params.message,
                        null,
                        params.payload,
                        params.trigger,
                    );
                    this.open();
                }
                if (type === "setVariables") {
                    this.sendMessage(
                        null,
                        null,
                        null,
                        null,
                        params
                    );
                    this.open();
                }
                if (type === "open") {
                    this.open();
                }
                if (type === "auth") {
                    if(params.auth) {
                        this.registerSession(params.auth)
                    }
                }
            } catch (e) {}
        });
    }

    messageAlert() {
        if (this.state.soundNotifications) {
            this.sound.play();
        }
    }

    updateSizeEnough(newValue) {
        if (this.state.sizeEnough !== newValue) {
            this.setState(
                {
                    sizeEnough: newValue,
                },
                () => {
                    this.updateSize();
                    this.scrollBottom();
                },
            );
        }
    }

    get isFullScreen() {
        return this.state.fullScreen || !this.state.sizeEnough || this.isEmbed;
    }

    scrollBottom() {
        if (!this.list) {
            return false;
        }
        if (this.state.open) {
            setTimeout(() => {
                this.setState({ newMessages: 0 }, () =>
                    this.list.scrollToBottom(),
                );
            }, 100);
        }
    }

    get list() {
        return this.widget && this.widget.list;
    }

    isScrolled() {
        if (!this.list) {
            return false;
        }
        return (
            this.list.getScrollTop() + 60 <
            this.list.getScrollHeight() - this.list.getClientHeight()
        );
    }

    get textTypeEnabled() {
        let lastMessage = this.state.messages.last();
        return (
            !(lastMessage && lastMessage.buttons) &&
            !this.state.typingMessage &&
            this.state.textEnabled
        );
    }


    get isExAuth() {
        return this.props.configs.exAuth;
    }



    componentDidMount() {
        if(this.isExAuth) {
            this.postMessage('wait-cookie');
        } else {
            this.registerSession();
        }
    }

    sendMessage(message, file, postback, trigger, variables, audio) {
        return this.setState({ textEnabled: false }, () => {
            let formData = new FormData();
            formData.append("message", message);
            if (file) {
                formData.append("file", file);
            }

            if (audio) {
                formData.append("file", audio);
            }

            formData.append(`url`, this.props.currentURL);

            if (variables) {
                for (let varName in variables) {
                    if (variables.hasOwnProperty(varName)) {
                        formData.append(`variables[${varName}]`, variables[varName]);
                    }
                }
            }
            if (postback) {
                formData.append("postback", postback);
                if (trigger) {
                    formData.append("trigger", trigger);
                }
            }

            this.webhook
                .post("", formData)
                .then(() => this.setState({ textEnabled: true }));
        });
    }

    getSessionName(key) {
        return [key, this.props.id].join("|");
    }

    registerSession(token) {

        this.client
            .post("/api/clients", {
                url: this.props.currentURL,
                integrationId: this.props.id,
                token: token
            })
            .then(({ data }) => {
                this.authorize(
                    data.id,
                    data.service_token,
                    data.webhook,
                    data.sessionId,
                );
                this.checkForInvite();
                this.setState(
                    {
                        using_live_chat: data.using_live_chat,
                        messages: List(
                            data.messages.map(
                                (message) => new MessageRecord(message),
                            ),
                        ),
                        authorized: true
                    },
                    () => {
                        setTimeout(() => {
                            this.updateSize();
                            this.scrollBottom();
                        }, 100)

                    },
                );
                this.postMessage("ready");
            });
    }

    closeInvite() {
        Cookies.set(this.getSessionName("block_invite"), "1", {
            sameSite: "None",
            secure: true,
        });
        if (this.inviteTimeout) {
            clearTimeout(this.inviteTimeout);
        }
        this.setState({ invite: false }, () => {
            this.updateSize();
        });
    }

    checkForInvite() {
        if (!Cookies.get(this.getSessionName("block_invite"))) {
            let autoOpenTime = this.props.configs.styles.config.auto_open_time;
            this.inviteTimeout = setTimeout(
                this.openInvite,
                autoOpenTime * 1e3,
            );
        }
    }

    openInvite() {
        setTimeout(() => {
            this.setState({ invite: true }, () => {
                this.updateSize();
            });
        });
    }

    authorize(id, token, webhook, sessionId) {
        if(!this.isExAuth) {
            Cookies.set(this.getSessionName("token"), token, {
                expires: 3650,
                sameSite: "None",
                secure: true,
            });
        }

        this.sessionId = sessionId;

        this.client.defaults.headers.common[
            "Authorization"
        ] = `Bearer ${token}`;

        this.webhook.defaults.headers.common[
            "Authorization"
        ] = `Bearer ${token}`;

        this.webhook.defaults.baseURL = webhook;

        const EchoServer = new Echo({
            broadcaster: "socket.io",
            host: this.props.baseURL,
            auth: {
                headers: {
                    Authorization: `Bearer ${token}`,
                    SessionID: sessionId,
                    ExAuth: this.isExAuth || ""
                },
            },
        });

        this.channel = EchoServer.private(`Client.${id}`);

        this.channel
            .listen("ClientNewMessage", (e) => {
                const wasScrolled = this.isScrolled();
                let messageRecord = new MessageRecord(e.message);
                if (!messageRecord.getIsOutcome()) {
                    this.messageAlert();
                }
                this.setState(
                    ({ messages }) => ({
                        messages: messages.push(messageRecord),
                        lastMessage: messageRecord,
                        botTyping: false,
                    }),
                    () => {
                        if (!this.state.open) {
                            this.openInvite();
                        }
                        if (!wasScrolled || messageRecord.getIsOutcome()) {
                            this.scrollBottom();
                        } else {
                            this.setState(({ newMessages }) => ({
                                newMessages: newMessages + 1,
                            }));
                        }
                    },
                );

                // this.props.onMessage && this.props.onMessage(e.message);
            })
            .listen("BotTyping", () => {
                const wasScrolled = this.isScrolled();
                this.setState({ botTyping: true }, () => {
                    if (!wasScrolled) {
                        this.scrollBottom();
                    }
                });
            })
            .listenForWhisper("answering", () => {
                if (!this.state.typing) {
                    let cb = this.isScrolled()
                        ? () => {
                              this.scrollBottom();
                          }
                        : () => {};
                    this.setState({ typing: true }, cb);
                }
            })
            .listenForWhisper("stop-answering", () => {
                if (this.state.typing) {
                    this.setState({ typing: false });
                }
            });
    }

    open() {
        if (!this.state.open) {
            this.setState({ open: true }, () => {
                this.scrollBottom();
                this.updateSize();
            });
        }
    }

    postMessage(event, params = {}) {
        window.parent.postMessage(JSON.stringify({ event, ...params }), "*");
    }

    updateSize() {
        if (this.state.open && this.isFullScreen) {
            this.postMessage("full-screen");
        } else {
            let body = document.body;
            this.postMessage("resize", {
                height: body.scrollHeight,
                width: body.scrollWidth,
            });
        }
    }

    toggleOpen() {
        this.setState(
            ({ open }) => ({ open: !open, fullScreen: false }),
            () => {
                this.state.open && this.scrollBottom();
                this.closeInvite();
            },
        );
    }

    toggleNotifications() {
        this.setState(({ soundNotifications }) => ({
            soundNotifications: !soundNotifications,
        }));
    }

    toggleFullScreen() {
        this.setState(
            ({ fullScreen }) => ({ fullScreen: !fullScreen }),
            () => {
                this.updateSize();
            },
        );
    }

    getMessageImage(message) {
        if (message.user) {
            return message.user.image
                ? `${message.user.image.path}`
                : this.props.configs.operator_image;
        }

        return this.props.configs.bot_image;
    }

    renderButton() {
        const { locale, styles } = this.props.configs;
        const settings = styles.config;
        const icon = settings.bubble_button_icon;

        const lastMessage = this.state.lastMessage;
        let hasAttachment = false;
        let imageUrl = this.props.configs.bot_image;
        let btnText;
        let mainText;
        let onStart;

        if (lastMessage) {
            if (lastMessage.getIsIncome()) {
                imageUrl = this.getMessageImage(lastMessage);
                imageUrl = imageUrl ? imageUrl : lastMessage.image;
            }

            hasAttachment = !!lastMessage.chat_message_attachments.length;
            btnText = settings.see_chat_btn_text[locale];
            mainText = lastMessage.message;
            onStart = () => {
                this.toggleOpen();
            };
        } else {
            btnText = settings.start_btn_text[locale];
            mainText = settings.button_start_chat_text[locale];
            onStart = () => {
                this.toggleOpen();
                this.sendMessage("start");
            };
        }

        const onStartStart = () => {
            onStart();
            this.client.post("/api/log-proactive-invitation")
        }

        return (
            <Invite
                invite={this.state.invite}
                closeInvite={this.closeInvite}
                onStart={onStartStart}
                toggleOpen={this.toggleOpen}
                btnText={btnText}
                mainText={mainText}
                icon={icon}
                hasAttachment={hasAttachment}
                imageUrl={imageUrl}
            />
        );
    }

    renderWidget() {
        const { logo, locale, powered_name, powered_url } = this.props.configs;

        const settings = this.props.configs.styles.config;
        const state = this.state;
        const messages = state.messages.toArray();

        if (state.botTyping) {
            messages.push(
                new MessageRecord({
                    type: TYPE_MESSAGE_BOT_OPERATOR,
                    message: () => <Writing />,
                }),
            );
        }

        return (
            <Widget
                ref={(ref) => (this.widget = ref)}
                messages={messages}
                title={settings.window_title[locale]}
                isFullScreen={this.isFullScreen}
                rtl={this.props.configs.rtl}
                soundNotifications={state.soundNotifications}
                toggleNotifications={this.toggleNotifications}
                toggleFullScreen={this.toggleFullScreen}
                embedButton={state.sizeEnough && !this.isEmbed}
                logo={logo}
                cardWidth={settings.card_width}
                toggleOpen={this.toggleOpen}
                closeButton={!this.isEmbed}
                sendMessage={this.sendMessage}
                start_btn={settings.start_btn_text[locale]}
                badge={settings.menu_badge_text[locale]}
                autostart_on_chat_page={this.props.configs.autostart_on_chat_page}
                menus={settings.menu_items.map((item) => {
                    return {
                        type: item.type,
                        href: item.value,
                        value: item.value,
                        title: item.text[locale],
                        icon: item.icon,
                    };
                })}
                getMessageImage={this.getMessageImage}
                botImage={this.props.configs.bot_image}
                opearatorImage={this.props.configs.operator_image}
                newMessages={state.newMessages}
                textTypeEnabled={this.textTypeEnabled}
                placeholder={settings.user_input_placeholder_text[locale]}
                poweredBy={false}
                powered_url={powered_url}
                powered_name={powered_name}
                channel={this.channel}
                scrollBottom={this.scrollBottom}
                using_live_chat={this.state.using_live_chat}
            />
        );
    }

    render() {

        if(!this.state.authorized) {
            return null;
        }

        return (
            <div className="chatbox-widget text-center">
                <Style styles={this.props.configs.styles} />
                {this.state.open && this.renderWidget()}
                <div />
                {!this.state.open && this.renderButton()}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./components/app/index.js